import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ExpertGroupPortalDataComponent } from './pages/expert-group-portal-data/expert-group-portal-data.component'
import { ExpertGroupPortalExpertListComponent } from './pages/expert-group-portal-expert-list/expert-group-portal-expert-list.component'
import { ExpertGroupPortalOverviewComponent } from './pages/expert-group-portal-overview/expert-group-portal-overview.component'
import { ExpertGroupPortalPostListComponent } from './pages/expert-group-portal-post-list/expert-group-portal-post-list.component'
import { ExpertGroupPortalResourcesListComponent } from './pages/expert-group-portal-resources-list/expert-group-portal-resources-list.component'
import { ExpertGroupPortalVideoListComponent } from './pages/expert-group-portal-video-list/expert-group-portal-video-list.component'
import { FuturesExplorerComponent } from './pages/futures-explorer/futures-explorer.component'
import { DiscussionDetailComponent } from './resources/discussion/discussion-detail/discussion-detail.component'
import { DiscussionListComponent } from './resources/discussion/discussion-list/discussion-list.component'

export const expertGroupPortalRoutes: Routes = [
  {
    path: '',
    component: ExpertGroupPortalOverviewComponent
  },
  {
    path: 'publications',
    component: ExpertGroupPortalResourcesListComponent
  },
  {
    path: 'external-resources',
    component: ExpertGroupPortalResourcesListComponent
  },
  {
    path: 'meeting-summaries',
    component: ExpertGroupPortalResourcesListComponent
  },
  {
    path: 'data',
    component: ExpertGroupPortalDataComponent
  },
  {
    path: 'videos',
    component: ExpertGroupPortalVideoListComponent
  },
  {
    path: 'blog-posts',
    component: ExpertGroupPortalPostListComponent
  },
  {
    path: 'experts',
    component: ExpertGroupPortalExpertListComponent
  },
  {
    path: 'discussions',
    component: DiscussionListComponent
  },
  {
    path: 'discussions/:slug',
    component: DiscussionDetailComponent
  },
  {
    path: 'explorer',
    component: FuturesExplorerComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(expertGroupPortalRoutes)],
  exports: [RouterModule]
})
export class ExpertGroupPortalRoutingModule {}
